<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" stretch="true" size="small">
      <el-tab-pane label="设备详情" name="first">
        <el-descriptions title="智能漏损定位终端" direction="vertical" :column="2" border>
          <el-descriptions-item label="设备串号">
            <el-tag>{{ press.deviceImei }}</el-tag>
          </el-descriptions-item>
          <!--          <el-descriptions-item label="采集时间">-->
          <!--            <el-tag size="small">{{ tacq }}</el-tag>-->
          <!--          </el-descriptions-item>-->
          <el-descriptions-item label="阀门状态">
            <el-tag type="success" size="small" v-if="press.valvStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.valvStatus===1">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="数据状态">
            <el-tag type="success" size="small" v-if="press.dataStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.dataStatus===2">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="水压状态">
            <el-tag type="success" size="small" v-if="press.waterStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.waterStatus===1">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="撞到状态">
            <el-tag type="success" size="small" v-if="press.knockDownStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.knockDownStatus===1">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="敲击状态">
            <el-tag type="success" size="small" v-if="press.knockStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.knockStatus===1">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="盒体状态">
            <el-tag type="success" size="small" v-if="press.separationStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.separationStatus===1">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="电压">
            <el-tag size="small">{{ press.voltage }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="温度">{{ press.temperature }}</el-descriptions-item>
          <el-descriptions-item label="水压"> {{ press.water }}</el-descriptions-item>
          <el-descriptions-item label="采集次数"> {{ press.sendNumber }}</el-descriptions-item>
          <el-descriptions-item label="安装位置"> {{ press.address }}</el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
    </el-tabs>
  </div>


</template>

<script>
import axios from "axios";

export default {
  name: "Press1",
  data() {
    return {
      activeName: "first",
      press: {
        DeviceIMEI: '',
        address: '',
        Status: '',
        WaterStatus: '',
        ValvStatus: '',
        KnockDownStatus: '',
        KnockStatus: '',
        SeparationStatus: '',
        Voltage: '',
        Temperature: '',
        Water: '',
        DeviceSignal: '',
        SendNumber: '',
      },
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      const imei = this.$route.query.imei
      axios.get("/virtual/api/press/yun/" + imei).then((res => {
        this.press = res.data.data
      }))
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/virtual/Press_virtual.vue